webpackJsonp([220747368961260],{

/***/ 882:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/BP_(033)C12744.55218289.jpg";

/***/ }),

/***/ 296:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _info = __webpack_require__(7);
	
	var _info2 = _interopRequireDefault(_info);
	
	var _BP_033C = __webpack_require__(882);
	
	var _BP_033C2 = _interopRequireDefault(_BP_033C);
	
	var _panoramic = __webpack_require__(24);
	
	var _panoramic2 = _interopRequireDefault(_panoramic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        _panoramic2.default,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'metadata--wrapper' },
	            _react2.default.createElement('img', { src: _BP_033C2.default, alt: '' }),
	            _react2.default.createElement(
	                _info2.default,
	                null,
	                'View of Quebec from Grant\'s Wharf ca 1790. Gravure de J.C. Stadler. Travels Through the Canadas, 1807.'
	            )
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 303:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _flexContainer = __webpack_require__(8);
	
	var _flexContainer2 = _interopRequireDefault(_flexContainer);
	
	var _sidebarLeft = __webpack_require__(12);
	
	var _sidebarLeft2 = _interopRequireDefault(_sidebarLeft);
	
	var _sidebarRight = __webpack_require__(13);
	
	var _sidebarRight2 = _interopRequireDefault(_sidebarRight);
	
	var _container = __webpack_require__(6);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _imageFooterAPropos = __webpack_require__(296);
	
	var _imageFooterAPropos2 = _interopRequireDefault(_imageFooterAPropos);
	
	var _hamburger = __webpack_require__(62);
	
	var _hamburger2 = _interopRequireDefault(_hamburger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SecondPage = function SecondPage() {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _flexContainer2.default,
	            null,
	            _react2.default.createElement(_reactHelmet2.default, { bodyAttributes: { class: 'hamburger' } }),
	            _react2.default.createElement(_sidebarLeft2.default, null),
	            _react2.default.createElement(
	                _container2.default,
	                null,
	                _react2.default.createElement(_hamburger2.default, null),
	                _react2.default.createElement(
	                    'h1',
	                    null,
	                    '\xC0 propos'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Ludovica est un projet d\u2019ide\u0301es, d\u2019e\u0301critures et d\u2019audio-visions initie\u0301 par David N. Bernatchez. Inspire\u0301 par Que\u0301bec, une ville aussi modeste en de\u0301mographie que riche en histoires et en r\xE9silience, le projet propose une sorte de distillerie fine. Personnages et lieux, me\u0301moires et archives, utopies et dystopies y mace\u0300rent en fragments. Regroup\xE9s autour de 5 grands axes, ces fragments sont articul\xE9s comme des parcours possibles. \xC9lixir \xE0 fermentation prolong\xE9e, le long me\u0301trage Ludovica verra le jour lors de la saison 2018-2019: avant donc, le retour des Nordiques...'
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    'h2',
	                    { className: 'like-h2' },
	                    'Personnes et personnages'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    '\xC0 l\u2019origine des personnages historiques se trouve une suite de personnes qui ont, en leur temps, agi pour le meilleur et pour le pire. D\u2019hier et d\u2019aujourd\u2019hui, inconnues ou reconnues: dans le moteur de Ludovica, les personnes deviennent des personnages.'
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'like-h2' },
	                    'Lieux'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Qu\'est-ce que l\'esprit d\'un lieu? Comment lire, dans l\'histoire et dans les m\xE9moires, des connexions entre les personnages, l\'esprit et le lieu? Les r\xE9ponses possibles sont nombreuses, les relations pouvant mourir vite ou durer tr\xE8s longtemps. On vous propose quelques pistes.'
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    'h4',
	                    { className: 'like-h2' },
	                    'Des collectifs en capsules'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Dans le cadre d\'une suite de capsules produites pour la Fabrique culturelle, je me suis int\xE9ress\xE9 \xE0 des d\xE9marches cr\xE9atives susceptibles de faire miroiter plus qu\'elles-m\xEAmes. J\u2019ai librement mis ces d\xE9marches en \xE9cho avec des fragments choisis, et j\u2019ai laiss\xE9 mijoter le tout sur la table de montage. ',
	                    _react2.default.createElement(
	                        'em',
	                        null,
	                        'EP4 percussion'
	                    ),
	                    ', ',
	                    _react2.default.createElement(
	                        'em',
	                        null,
	                        'Les Violons du Roy'
	                    ),
	                    ', ',
	                    _react2.default.createElement(
	                        'em',
	                        null,
	                        'l\u2019Orchestre d\u2019Hommes-Orchestres'
	                    ),
	                    ' et ',
	                    _react2.default.createElement(
	                        'em',
	                        null,
	                        'La F\xEAte'
	                    ),
	                    ' m\'ont fait confiance et je les en remercie. Ils contribuent tous, \xE0 leur mani\xE8re, \xE0 faire de Qu\xE9bec plus qu\'un reflet d\'elle-m\xEAme. Dans une ville habit\xE9e par l\u2019histoire et mise-en-sc\xE8ne comme telle, ce mouvement est d\'autant plus n\xE9cessaire: il aide \xE0 garder les choses en vie.'
	                )
	            ),
	            _react2.default.createElement(_sidebarRight2.default, null)
	        ),
	        _react2.default.createElement(_imageFooterAPropos2.default, null)
	    );
	};
	
	exports.default = SecondPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-a-propos-js-139eee34fa0e357a5984.js